import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '@environments/environment';
import {FactureTypeCharge} from '@domain/facture/facture-type-charge';
import {Result} from '@domain/common/http/result';

/**
 * Service de gestion des types de charges
 */
@Injectable()
export class FraisFacturesService {
    /**
     * Indique si une page de détail d'un objet Factures (relevés, fournisseurs...) a été ouverte.
     * Cela permet de savoir s'il faut afficher les listes du menu Factures ou non.
     */
    isShowDetail: boolean;

    /**
     * Constructeur
     * @param http 	httpClient
     */
    constructor(private http: HttpClient) {
    }

    /**
     * Suppression des types de charges sélectionnés.
     * @param listeObjetsSectionnes Liste des types de charges à supprimer
     * @returns Un Observable contenant le résultat de l'opération
     */
    deleteTypesCharges(listeObjetsSectionnes: FactureTypeCharge[]): Observable<Result> {
        //Extraction des IDs des types de charges à supprimer
        const listeIds = listeObjetsSectionnes.map(item => item.idTypeCharge);

        //Appel au backend pour supprimer les types de charges
        return this.http.post<Result>(`${environment.baseUrl}/controller/typeCharge/delete`, listeIds);
    }
}
